<template lang="pug">
.customer-fields
  .grid-1-1
    BriqInput(label="First name" required :disabled="disabled" v-model.trim="customer.Firstname" data-test-id="customer-first-name")
    BriqInput(label="Last name" required :disabled="disabled" v-model.trim="customer.Lastname" data-test-id="customer-last-name")
  BriqInput(label="E-mail" optional :disabled="disabled" v-model="customer.Email" type="email" data-test-id="customer-email")
  BriqInput(label="Phone number" optional :disabled="disabled" v-model="customer.Mobilenumber" data-test-id="customer-phone-number")
</template>

<script>
export default {
  name: 'CustomerFields',
  props: {
    customer: Object,
    disabled: Boolean,
  },
}
</script>

<style scoped lang="stylus">
.grid-1-1
  display grid
  grid-template-columns 1fr 1fr
  grid-gap 15px
</style>

<style lang="stylus">
.customer-fields .briq-form-element
  margin-bottom 24px
</style>
